import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Icon, Header, Label, Pagination, Confirm } from 'semantic-ui-react';
import Table from 'semantic-table-grid';
import GestioneAvvisoService from 'shared/services/rpc/gestione-avviso';
import AvvisoService from 'shared/services/api/internokiron/avviso';

import EditorAvvisiModal from '../../components/EditorAvvisi/Form';
import { mapToInitialValues } from '../../components/EditorAvvisi/Form/initialValues';

import { BtnWithActions } from '../../components/Buttons';
import Modal from '../../components/Modal';
import FilterBar from '../../components/EditorAvvisi/FilterBar';

export class EditorAvvisi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      elements: [],
      isLoading: false,
      modalOpened: false,
      formikValues: null,

      page: 1,
      pageCount: 0,
      pageSize: 0,
      totalItems: 0,

      deleteMessage: false,
      currentMessage: null,
      lastSearch: '',
      search: '',
      orderField: null,
      orderDirection: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  onClose = () =>
    this.setState({
      modalOpened: false,
      formikValues: null,
    });

  onNew = () => this.setState({ modalOpened: true }, document.body.classList.add('scrolling', 'dimmable', 'dimmed'));

  onEdit = (data) =>
    this.setState({
      formikValues: mapToInitialValues(data),
      modalOpened: true,
    });

  onOpen = (data) => {
    this.setState({
      formikValues: mapToInitialValues(data),
      modalOpened: true,
    });
  };

  /** Close modal to delete candidate */
  onDelete = () => {
    AvvisoService.delAvviso(this.state.currentMessage.id)
      .then(() => {
        this.closeModalDeleteMessage();
        this.loadData();
        this.props.notification().addNotification({
          message: 'Avviso eliminato con successo',
          level: 'success',
        });
      })
      .catch((err) => {
        this.props.notification().addNotification({
          message: err.data.detail || "Si è vericato un problema con la cancellazione dell'avviso",
          level: 'error',
        });
      });
  };

  getLabelColor = (data) => {
    const stato = _.get(data, 'gravita').toLowerCase();
    if (stato === 'error') return 'red';
    if (stato === 'warning') return 'yellow';
    if (stato === 'info') return 'blue';
    return 'grey';
  };

  getActions = (data) =>
    [
      {
        icon: 'edit',
        label: 'Modifica',
        action: () => {
          this.onEdit(data);
        },
      },
      {
        icon: 'delete',
        label: 'Elimina',
        action: () => this.setState({ deleteMessage: true, currentMessage: data }),
      },
      {
        icon: 'bell',
        label: 'Invia notifica app',
        action: () => this.appNotification(data),
      },
    ].filter(Boolean);

  appNotification = ({ messaggio }) => {
    GestioneAvvisoService.sendAppNotification(messaggio)
      .then(() => {
        this.props.notification().addNotification({
          message: 'Invio notifica avvenuto con successo',
          level: 'success',
        });
      })
      .catch((err) => {
        this.props.notification().addNotification({
          message: err.data.detail || "Si è vericato un problema con l'invio della notifica",
          level: 'error',
        });
      });
  };

  closeModalDeleteMessage = () => this.setState({ deleteMessage: false });

  loadData = (page, filters = {}) => {
    this.setState({ isLoading: true });

    AvvisoService.getMessagesWithSearch(page, filters, this.state.orderField, this.state.orderDirection).then((res) => {
      this.setState({
        elements: res._embedded.avviso,
        pageCount: res.page_count,
        pageSize: res.page_size,
        totalItems: res.total_items,
        page,
        isLoading: false,
        lastSearch: filters,
      });
    });
  };

  columns = () => [
    {
      key: 'messaggio',
      name: 'Messaggio',
      formatter: null,
      sortable: true,
    },
    {
      key: 'gravita',
      name: 'Gravità',
      formatter: ({ data }) => (
        <Label style={{ position: 'relative' }} color={this.getLabelColor(data)}>
          {data.gravita}
        </Label>
      ),
      sortable: true,
    },
    {
      key: 'attivo',
      name: 'Attiva',
      formatter: ({ data }) => (
        <div style={{ textAlign: 'center' }}>
          {data.attivo ? <Icon color="green" name="checkmark" /> : <Icon color="red" name="remove" />}
        </div>
      ),
      sortable: true,
    },
    {
      key: 'actions',
      name: 'Azioni',
      formatter: ({ data }) => <BtnWithActions key="other-actions" actions={this.getActions(data)} otherActions={[]} />,
      sortable: false,
      width: 10,
    },
  ];

  searchChange = (_event, data) => this.setState({ search: data.value });

  render() {
    return (
      <div>
        <Helmet>
          <title>Editor avvisi</title>
          <meta name="description" content="Editor avvisi" />
        </Helmet>
        <Header as="h2" style={{ marginTop: 15 }}>
          <Icon name="text cursor" />
          <Header.Content>
            Gestione editor avvisi
            <Header.Subheader>Creazione e modifica avvisi</Header.Subheader>
          </Header.Content>
        </Header>
        <Table
          isLoading={this.state.isLoading}
          columns={this.columns()}
          canAction={{
            actions: <FilterBar loadData={this.loadData} addMessage={this.onNew} />,
            active: true,
          }}
          elements={this.state.elements}
          canPaginate={{
            active: true,
            render: (
              <Pagination
                activePage={this.state.page || 0}
                boundaryRange={1}
                onPageChange={(e, { activePage }) =>
                  this.setState({ page: activePage }, () => this.loadData(activePage, this.state.lastSearch))
                }
                size="mini"
                siblingRange={1}
                totalPages={this.state.pageCount || 0}
                ellipsisItem={'...'}
              />
            ),
          }}
          canSort={{
            active: true,
            onSort: (field, dir) => {
              this.setState({ orderField: field, orderDirection: dir }, () =>
                this.loadData(this.state.page, this.state.lastSearch)
              );
            },
          }}
        />
        <Modal
          open={this.state.modalOpened}
          onClose={this.onClose}
          title={
            <h2>
              <Icon name="text cursor" /> Nuovo avviso
            </h2>
          }
          size="tiny"
        >
          <EditorAvvisiModal
            startEdit={this.onStartEdit}
            onEdit={this.onEdit}
            update={() => this.loadData()}
            close={this.onClose}
            notifications={this.props.notification()}
            initialValues={this.state.formikValues ? this.state.formikValues : null}
          />
        </Modal>
        <Confirm
          size="tiny"
          content="Sei sicuro di voler eliminare l'avviso?"
          open={this.state.deleteMessage}
          cancelButton="Annulla"
          confirmButton="Conferma"
          onCancel={this.closeModalDeleteMessage}
          onConfirm={this.onDelete}
        />
      </div>
    );
  }
}

EditorAvvisi.propTypes = {
  notification: PropTypes.func,
};

export default EditorAvvisi;



// WEBPACK FOOTER //
// ./app/containers/EditorAvvisi/index.js